import React from 'react';
import { PeekDialog } from '@piiqtechnologies/ui-components';
import '../../../../../types/AccessDevice.js';
import '../../../../../types/Analytics.js';
import '../../../../../types/CASACommunity.js';
import '../../../../../types/Community.js';
import '../../../../../types/DxSettings.js';
import '../../../../../types/MagicButton.js';
import '../../../../../types/Pannellum.js';
import '../../../../../types/Prospect.js';
import '../../../../../types/ProspectIntelligence.js';
import { HotspotType } from '../../../../../types/Space.js';
import '../../../../../types/Tour.js';
import { SceneHotspot } from './SceneHotspot.js';
import { SpaceHotspot } from './SpaceHotspot.js';
import { InfoHotspot } from './InfoHotspot.js';
import { usePannellumViewer } from '../../../../components/pannellum-viewer/PannellumProvider.js';

const CreateHotspotModal = ({ onCreateNodeLink, onCreateInfospot, hotspotType, open, onCloseCreateHotSpotModal, }) => {
    const { getContainer } = usePannellumViewer();
    return (React.createElement(PeekDialog, { open: open, sx: { position: "absolute", zIndex: 9999 }, container: getContainer().parentElement, maxWidth: "xs", onClose: onCloseCreateHotSpotModal, fullWidth: true, PaperProps: { sx: { p: 2 } } },
        hotspotType === HotspotType.Info && (React.createElement(InfoHotspot, { onHotspotCreation: onCreateInfospot, onCloseModal: onCloseCreateHotSpotModal })),
        hotspotType === HotspotType.Node && React.createElement(SceneHotspot, { onHotspotCreation: onCreateNodeLink }),
        hotspotType === HotspotType.Space && React.createElement(SpaceHotspot, { onHotspotCreation: onCreateNodeLink })));
};

export { CreateHotspotModal, CreateHotspotModal as default };
